/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PSPulse API
 * South Tyrol Pronto Soccorso queue data — with a memory: history, trends, and forecasts. Data source: the CC0 PS_Queue feed from Open Data Südtirol (https://dati.retecivica.bz.it/). Tier-1 read endpoints (live overview, per-hospital history, day×hour heatmap, estimated wait) are live; the estimated-wait figures are deliberately rough, drain-rate estimates.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CollectorStatusResponse
} from '../model';

import { customAxiosInstance } from '../../axios-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Reports whether the background collector is polling successfully and how fresh the data is (seconds since the last successful poll). Powers a "data is live / last updated" indicator. Always 200; before the first poll, isHealthy is false with null timestamps.
 * @summary Collector freshness & health
 */
export const getCollectorStatus = (

 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<CollectorStatusResponse>(
      {url: `/status`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetCollectorStatusQueryKey = () => {
    return [
    `/status`
    ] as const;
    }


export const getGetCollectorStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCollectorStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectorStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollectorStatus>>> = ({ signal }) => getCollectorStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectorStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCollectorStatus>>>
export type GetCollectorStatusQueryError = unknown


export function useGetCollectorStatus<TData = Awaited<ReturnType<typeof getCollectorStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectorStatus>>,
          TError,
          Awaited<ReturnType<typeof getCollectorStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectorStatus<TData = Awaited<ReturnType<typeof getCollectorStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectorStatus>>,
          TError,
          Awaited<ReturnType<typeof getCollectorStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectorStatus<TData = Awaited<ReturnType<typeof getCollectorStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Collector freshness & health
 */

export function useGetCollectorStatus<TData = Awaited<ReturnType<typeof getCollectorStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectorStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectorStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






